module.exports = __webpack_public_path__ + "img/product7.89ad1819.png";